import { Box, Grid, Typography } from "@mui/material";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis, Cell } from "recharts";
import api from "../services/Axios";
import { useEffect, useState } from "react";

const CHART_STYLE = {
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    border: "1px solid #EEF0F5",
    boxShadow: "0 2px 8px rgba(17,19,26,0.04)",
};

const BAR_COLORS = [
    "#3B7DDD", "#66BB6A", "#FFA726", "#EC407A", "#AB47BC",
    "#26A69A", "#5C6BC0", "#EF5350", "#8D6E63", "#26C6DA",
];

export default function LandingPageSessions({ dateRange, onLoadingChange }) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const getData = async () => {
        const requestId = `landing-page-sessions-${Date.now()}-${Math.random()}`;
        setLoading(true);
        onLoadingChange(requestId, true);
        try {
            const res = await api.get("/admin/analytics/ga/landing-pages", {
                params: dateRange,
            });
            setData(res?.data?.rows || []);
        } finally {
            setLoading(false);
            onLoadingChange(requestId, false);
        }
    };

    useEffect(() => {
        getData();
    }, [dateRange, onLoadingChange]);

    return (
        <Grid item xs={12} md={6}>
            <Box borderRadius={2} p={2.5} sx={CHART_STYLE} height="100%">
                <Typography variant="h6" mb={2}>Sessions by Landing Page</Typography>

                {!loading && (
                    <ResponsiveContainer width="100%" height={Math.max(280, data.length * 48)}>
                        <BarChart data={data} layout="vertical" margin={{ left: 20 }}>
                            <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.06)" horizontal={false} />
                            <XAxis type="number" stroke="#888" fontSize={12} />
                            <YAxis
                                type="category"
                                dataKey="landing_page"
                                stroke="#888"
                                fontSize={12}
                                width={100}
                            />
                            <Tooltip contentStyle={{ background: "#fff", border: "1px solid #333" }} />
                            <Bar dataKey="sessions" radius={[0, 4, 4, 0]} barSize={22}>
                                {data.map((_, i) => (
                                    <Cell key={i} fill={BAR_COLORS[i % BAR_COLORS.length]} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                )}
            </Box>
        </Grid>
    );
}